import { render, staticRenderFns } from "./IsLoading.vue?vue&type=template&id=c2ea9d50&scoped=true"
import script from "./IsLoading.vue?vue&type=script&lang=ts"
export * from "./IsLoading.vue?vue&type=script&lang=ts"
import style0 from "./IsLoading.vue?vue&type=style&index=0&id=c2ea9d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ea9d50",
  null
  
)

export default component.exports